import { Routes } from '@angular/router';

import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';




export const reportsRoutes: Routes = [
  {
    path: 'reports',
    loadComponent: () => import('./reports.component').then(m => m.ReportsComponent),
    children: [
      {
        path: 'historical-rides-report',
        loadComponent: () => import('./pages/historical-rides-report/historical-rides-report.component').then(m => m.HistoricalRidesReportComponent),
        title: 'Historical Rides Report | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ClientRideFinderReportView],
          ],
        },
        canActivate: [AuthorizationGuard],
      },
      {
        path: 'no-show-report',
        loadComponent: () => import('./pages/no-show-report/no-show-report.component').then(m => m.NoShowReportComponent),
        title: 'No Show Report | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ClientNoShowReportView],
          ],
        },
        canActivate: [AuthorizationGuard],
      },
      {
        path: 'consecutive-no-show-report',
        loadComponent: () => import('./pages/consecutive-no-show-report/consecutive-no-show-report.component').then(m => m.ConsecutiveNoShowReportComponent),
        title: 'Consecutive No Show Report | ADROIT',
        data: {
          PermissionPageName: [
            PermissionsList[PermissionsList.ClientConsecutiveNoShowReportView],
          ],
        },
        canActivate: [AuthorizationGuard],
      },
    ],
  },
];
